import { createAPI } from '@/plugins/axios'

const zhaopin = {
  deleteJianli: params => createAPI(`/zhaopin/jianli/delete2`, 'post', params)
}

const message = {
  check: params => createAPI(`/message/check`, 'post', params)
}

const record = {
  getcontent: params => createAPI(`/aliapi/getcontent`, 'get', params)
}

export { zhaopin, message, record }
